// extracted by mini-css-extract-plugin
module.exports = {"marker":"marker_marker__3wVxd"};